import { BrokerLicenseField } from '@hcs/types';

export const licenseTemplate = {
  [BrokerLicenseField.LicenseState]: null,
  [BrokerLicenseField.Number]: null,
  [BrokerLicenseField.Expiration]: null,
  [BrokerLicenseField.Name]: null,
  [BrokerLicenseField.AddressLine1]: null,
  [BrokerLicenseField.AddressLine2]: null,
  [BrokerLicenseField.City]: null,
  [BrokerLicenseField.State]: null,
  [BrokerLicenseField.Zipcode]: null,
  [BrokerLicenseField.Email]: null,
  [BrokerLicenseField.Phone]: null,
};
